import {isAllowed} from '../../../../../viscomjs/utils/MediaAutoplaySupport';
import {CoreModel} from '../../model/CoreModel';

const DefineInitialSoundState = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        CoreModel.instance().soundOn = isAllowed;

        resolve(doThat);
    });
};

export {DefineInitialSoundState};
